/**
  Author: Suneel Singh - suneel.singh@enabledata.com
  Purpose: Policy services
  Date: may 2020
**/

import axios from 'axios';

const headers = {
  'Content-type': 'application/json',
  'Cache-Control': `no-cache`,
  //Authorization: `Bearer ${localStorageService.getAccessToken()}`,
};
const API = axios.create({
  headers,
});


const baseURL = process.env.REACT_APP_MYPOLICIES_API_URL;

const jsonToURLString = (jsonObject={}) => {

  const params = new URLSearchParams();

  // Convert JSON object to URL parameters
  Object.entries(jsonObject).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      params.append(key, value.join(",")); // Join array values with commas
    } else {
      if (value) {
        params.append(key, value);
      }
    }
  });

  return params.toString();
}

export const getPolicyContent = (payload) => {

  let url = `${baseURL}/policy-portal/content/${encodeURIComponent(payload.orgId)}/${encodeURIComponent(payload.policyId)}/${encodeURIComponent(payload.vid)}`

  if (payload.accessToken && payload.accessToken.length>0) {
    url = url + `?access_token=${payload.accessToken}`
  }

  return API.get(url, {
    headers: {},
  });

};

export const getDataFromPreSignedURL = (preSignedURL) => {
  return API.get(preSignedURL, {
    headers: { },
  });
};


export const searchPolicies = (payload) => {


  let url = `${baseURL}/policy-portal/listing/${encodeURIComponent(payload.orgId)}?${jsonToURLString(payload)}`

  return API.get(url, {
    headers: {},
  });

};


export const getPolicy = (id) => {
  return API.get(`policies/policies/${id}?record_view=record_deactivate`, {
    headers: { },
  });
};

